import { createRouter } from 'vue-router'
import HomePage from './home/HomePage.vue'
import ObjectsPage from './objects/ObjectsPage.vue'
import SettingsPage from './settings/SettingsPage.vue'
import DeployPage from './deploy/DeployPage.vue'
import ObjectPage from './objects/ObjectPage.vue'
import LogsPage from './logs/LogsPage.vue'
import OperationsPage from './operations/OperationsPage.vue'
import AnomaliesPage from './anomalies/AnomaliesPage.vue'
import AnomalyPage from './anomalies/AnomalyPage.vue'
import ODataPage from './odata/ODataPage.vue'
import NotFoundPage from './NotFoundPage.vue'
import LoginPage from './login/LoginPage.vue'

/** @type {readonly import('vue-router').RouteRecordRaw[]} */
const routes = [
  {
    path: '/',
    component: HomePage,
    name: 'Home',
    meta: {
      title: 'Dashboard'
    }
  },

  {
    path: '/objects',
    children: [
      {
        path: '',
        component: ObjectsPage,
        meta: {
          title: 'All Mappings'
        }
      },
      {
        path: '/objects/:objectName',
        component: ObjectPage,
        meta: {
          title: (route) => route.params.objectName + ' Mapping'
        }
      }
    ]
  },

  {
    path: '/settings/',
    component: SettingsPage,
    meta: {
      title: 'Settings'
    }
  },

  {
    path: '/operations-queue',
    component: OperationsPage,
    meta: {
      title: 'Operations Queue'
    }
  },

  {
    path: '/deploy',
    component: DeployPage,
    meta: {
      title: 'Deploy'
    }
  },

  {
    path: '/sync-logs',
    component: LogsPage,
    meta: {
      title: 'Sync Logs'
    }
  },

  {
    path: '/odata',
    component: ODataPage,
    meta: {
      title: 'OData'
    }
  },

  {
    path: '/anomalies',
    children: [
      {
        path: '',
        component: AnomaliesPage,
        meta: {
          title: 'Anomalies'
        }
      },
      {
        path: '/anomalies/:anomalyId',
        component: AnomalyPage,
        meta: {
          title: 'Anomaly Details'
        }
      }
    ]
  },

  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: {
      title: 'Login'
    }
  },

  {
    path: '/:catchAll(.*)',
    name: 'Not Found',
    component: NotFoundPage,
    meta: {
      title: '404 - Page Not Found'
    }
  },
]

export default function (history) {
  return createRouter({
    history,
    routes,
    scrollBehavior (to, from, savedPosition) {
      // always scroll to top
      document.getElementById('main-container').scrollTop = 0
      return { top: 0 }
    },
  })
}
